// src/version.js
// Single source of truth for the version LABEL (display only).
// Vite injects the number at build time via the __APP_VERSION__ define
// (see vite.config.js).
//
// 2026-08-08: источник номера — git, а НЕ поле package.json (последний тег vX.Y.Z +
// шаги до HEAD по первому родителю, backend/utils/resolve-version.cjs). Поле в
// package.json осталось только фолбэком на случай отсутствия git или тегов; бампать
// его для релиза не нужно и не следует. Раньше здесь было написано ровно обратное.
//
// ⚠️ VERSION is now a DISPLAY-ONLY label — it does NOT drive the reload logic.
// Reload is triggered exclusively by BUILD_HASH mismatch (msg.bh ≠ INITIAL_BUILD_HASH
// in the WS heartbeat). This eliminates the "4 places" maintenance burden — nothing
// needs a manual bump at all.
//
// For tests and non-Vite environments __APP_VERSION__ is undefined, so we fall
// back to '0.0.0-dev' — this is intentional and tested.
export const VERSION = (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0-dev');
